var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M16.594 8.578l1.406 1.406-6 6-6-6 1.406-1.406 4.594 4.594z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }